import React from "react";
import { FaLanguage } from "react-icons/fa";

import { getJapaneseTerm, getTranslation } from "../utils/lexiqueUtils";

function LexiqueCard({ item }) {
  const japonais = getJapaneseTerm(item);
  const traduction = getTranslation(item);

  return (
    <article className="group rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 transition hover:-translate-y-0.5 hover:bg-white hover:shadow-lg dark:border-white/10 dark:bg-white/[0.04] dark:hover:bg-white/[0.07]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-indigo-700 shadow-sm dark:bg-white/10 dark:text-indigo-200">
          <FaLanguage />
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="break-words font-titre text-xl font-bold text-slate-950 dark:text-white">
            {japonais || "Terme non renseigné"}
          </h3>

          <p className="mt-2 break-words text-sm font-medium italic leading-6 text-slate-600 dark:text-white/60">
            {traduction || "Traduction non renseignée"}
          </p>
        </div>
      </div>
    </article>
  );
}

export default LexiqueCard;